/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdAlertProps } from './type';

export const alertDefaultProps: TdAlertProps = { close: false, closeBtn: false, maxLine: 0, theme: 'info' };
